module.exports = __webpack_public_path__ + "static/img_life_saving_gift_banner_01-9137919c6b8bce4f64865786ca2e3304.png";